import React from 'react'
import { RouterProvider } from 'react-router'
import '@ant-design/v5-patch-for-react-19';

import ErrorBoundary from './components/ErrorBoundary'
import router from './router'
import { Auth0Provider } from '@auth0/auth0-react';

const App: React.FC = () => (
  <Auth0Provider
    domain="nivo.jp.auth0.com"
    clientId="uddGaQzJ2PDRWO1lm9MIbyXO4siajCax"
    authorizationParams={{
        // redirect_uri: window.location.origin + "/auth",
        redirect_uri: window.location.origin,
    }}
  >
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </Auth0Provider>
)
App.displayName = 'App'
export default App
